var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNenhumareserva001(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 626.73 458.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #2d2165;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-7, .cls-6 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-7, .cls-6 {\n        stroke-width: 4.04px;\n      }\n\n      .cls-8 {\n        fill: #6543fa;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-width: 4.02px;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        fill: #7041ff;\n      }\n\n      .cls-5 {\n        fill: #fcfdfd;\n      }\n\n      .cls-7 {\n        stroke: #fcfdfd;\n      }\n\n      .cls-6 {\n        stroke-dasharray: 3.96 3.96;\n      }\n\n      .cls-11 {\n        fill: #94d8f4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586.85,353.86c9.03-1.37,15.26-9.76,13.96-18.8L554.54,11.58c-.85-5.96-5.66-10.2-10.75-9.47L9.81,83.52c-5.08.73-8.51,6.15-7.66,12.11l46.23,323.19c1.31,9.15,9.83,15.48,18.97,14.09l519.5-79.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.62,104.54c.47,3.25-1.79,6.27-5.05,6.73-3.25.46-6.27-1.79-6.73-5.05-.46-3.25,1.8-6.27,5.05-6.73,3.25-.47,6.27,1.8,6.73,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.92,102.07c.47,3.25-1.8,6.27-5.05,6.73-3.25.47-6.26-1.79-6.73-5.05-.46-3.25,1.79-6.26,5.04-6.73,3.25-.47,6.27,1.8,6.73,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M71.21,99.59c.47,3.25-1.79,6.27-5.04,6.73-3.25.47-6.27-1.79-6.73-5.05-.46-3.25,1.8-6.27,5.05-6.73,3.25-.46,6.26,1.8,6.73,5.05Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "265.08 65.44 467.13 114.27 505.43 176.99 437.42 458.41 184.86 397.37 265.08 65.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "459.91 112.52 445.96 170.25 503.69 184.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 398.97,
    y1: 250.89,
    x2: 437,
    y2: 259.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 405.94,
    y1: 222.03,
    x2: 443,
    y2: 230.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 288.41,
    y1: 284.92,
    x2: 425.52,
    y2: 318.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 281.44,
    y1: 313.79,
    x2: 418.54,
    y2: 346.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 274.46,
    y1: 342.65,
    x2: 411.57,
    y2: 375.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 259.55,
    y1: 277.95,
    x2: 273.98,
    y2: 281.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 252.57,
    y1: 306.81,
    x2: 267.01,
    y2: 310.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 245.6,
    y1: 335.67,
    x2: 260.03,
    y2: 339.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 189.96,
    y1: 361.12,
    x2: 56.28,
    y2: 263.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 206.43,
    y1: 338.63,
    x2: 72.75,
    y2: 240.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 231.54,
    y1: 374.46,
    x2: 220.4,
    y2: 366.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.86,
    y1: 268.45,
    x2: 80.02,
    y2: 246.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 156.69,
    y1: 336.44,
    x2: 172.86,
    y2: 314.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 190.11,
    y1: 360.91,
    x2: 206.27,
    y2: 338.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 167.83,
    y1: 344.6,
    x2: 173.27,
    y2: 337.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 178.97,
    y1: 352.76,
    x2: 184.41,
    y2: 345.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 178.71,
    y1: 329.74,
    x2: 184.15,
    y2: 322.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 189.85,
    y1: 337.9,
    x2: 195.29,
    y2: 330.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "190.11 360.91 224.26 368.81 206.43 338.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.57,271.17l-11.14-8.16c-4.1-3-4.99-8.76-1.99-12.87l5.44-7.43c3-4.1,8.76-4.99,12.87-1.99l11.14,8.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "93.15 206 171.39 206 199 224.41 199 206 212.81 206 212.81 17.29 93.15 17.29 93.15 206"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 116.16,
    y1: 44.91,
    x2: 189.8,
    y2: 44.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 116.16,
    y1: 63.32,
    x2: 189.8,
    y2: 63.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 116.16,
    y1: 81.73,
    x2: 189.8,
    y2: 81.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 116.16,
    y1: 136.96,
    x2: 189.8,
    y2: 136.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 116.16,
    y1: 155.37,
    x2: 189.8,
    y2: 155.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 116.16,
    y1: 173.78,
    x2: 189.8,
    y2: 173.78
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 175.99,
    y1: 109.35,
    x2: 166.79,
    y2: 109.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 157.58,
    y1: 109.35,
    x2: 148.38,
    y2: 109.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 139.17,
    y1: 109.35,
    x2: 129.97,
    y2: 109.35
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M389.79,136.19s.22-.67.69-1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M391.99,130.65c7.64-17.45,36.38-69.93,104.94-66.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M498.92,64.06c.67.04,1.35.09,2.03.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 566.03,
    cy: 86.7,
    r: 60.71,
    transform: "translate(104.48 425.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M583.56,63.66l-16.74,14.02-14.02-16.74c-2.27-2.71-6.31-3.07-9.02-.8s-3.07,6.31-.8,9.02l14.02,16.74-16.74,14.02c-2.71,2.27-3.06,6.31-.79,9.02,2.27,2.7,6.3,3.06,9.01.8l16.74-14.02,14.02,16.74c2.27,2.71,6.31,3.06,9.02.79,2.7-2.27,3.06-6.3.8-9.01l-14.02-16.74,16.74-14.02c2.71-2.27,3.07-6.31.8-9.02-2.27-2.71-6.31-3.07-9.02-.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.72,
    y: 148.72,
    width: 114.83,
    height: 93.5,
    transform: "translate(52.78 -70.22) rotate(13.06)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 284.58,
    y1: 150.68,
    x2: 396.45,
    y2: 176.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 300.25,
    y1: 146.23,
    x2: 303.81,
    y2: 130.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 314.26,
    y1: 149.48,
    x2: 317.83,
    y2: 134.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 328.28,
    y1: 152.73,
    x2: 331.84,
    y2: 137.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.29,
    y1: 155.98,
    x2: 345.86,
    y2: 140.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 356.31,
    y1: 159.23,
    x2: 359.87,
    y2: 143.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 370.33,
    y1: 162.48,
    x2: 373.89,
    y2: 147.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 384.34,
    y1: 165.73,
    x2: 387.9,
    y2: 150.38
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 322.06,
    y1: 179.31,
    x2: 327.01,
    y2: 180.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 331.95,
    y1: 181.6,
    x2: 336.9,
    y2: 182.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.85,
    y1: 183.9,
    x2: 346.79,
    y2: 185.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 351.74,
    y1: 186.19,
    x2: 356.69,
    y2: 187.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 361.64,
    y1: 188.49,
    x2: 366.58,
    y2: 189.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 299.98,
    y1: 184.61,
    x2: 304.92,
    y2: 185.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 309.87,
    y1: 186.91,
    x2: 314.82,
    y2: 188.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 319.76,
    y1: 189.2,
    x2: 324.71,
    y2: 190.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 329.66,
    y1: 191.5,
    x2: 334.61,
    y2: 192.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.55,
    y1: 193.79,
    x2: 344.5,
    y2: 194.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 349.45,
    y1: 196.09,
    x2: 354.39,
    y2: 197.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 359.34,
    y1: 198.38,
    x2: 364.29,
    y2: 199.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 297.68,
    y1: 194.51,
    x2: 302.63,
    y2: 195.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.58,
    y1: 196.8,
    x2: 312.52,
    y2: 197.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 317.47,
    y1: 199.1,
    x2: 322.42,
    y2: 200.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.36,
    y1: 201.39,
    x2: 332.31,
    y2: 202.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 337.26,
    y1: 203.69,
    x2: 342.2,
    y2: 204.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 347.15,
    y1: 205.98,
    x2: 352.1,
    y2: 207.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 357.05,
    y1: 208.28,
    x2: 361.99,
    y2: 209.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 295.39,
    y1: 204.4,
    x2: 300.33,
    y2: 205.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 305.28,
    y1: 206.69,
    x2: 310.23,
    y2: 207.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 315.17,
    y1: 208.99,
    x2: 320.12,
    y2: 210.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 325.07,
    y1: 211.28,
    x2: 330.02,
    y2: 212.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 334.96,
    y1: 213.58,
    x2: 339.91,
    y2: 214.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.86,
    y1: 215.87,
    x2: 349.8,
    y2: 217.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 354.75,
    y1: 218.17,
    x2: 359.7,
    y2: 219.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 293.09,
    y1: 214.29,
    x2: 298.04,
    y2: 215.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 302.99,
    y1: 216.59,
    x2: 307.93,
    y2: 217.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 312.88,
    y1: 218.88,
    x2: 317.83,
    y2: 220.03
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNenhumareserva001);
export default __webpack_public_path__ + "static/media/Nenhuma reserva 001.c655c98bc60ec789dc26ac8c4ab4914b.svg";
export { ForwardRef as ReactComponent };